module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 4-ad8d7579e39443119a1490f824aadf50.jpg";